// src/components/ChatWindow.tsx

import React, { useState, useEffect, useRef } from 'react';
import { AnalysisResult, ChatMessage, ChatWindowProps } from '../types';
import Message from './Message';
import ChatIntroPopup from './ChatIntroPopup';
// css imported globally in index.tsx



// css imported globally in index.tsx


// 2. Accept the new props (added selectedTemplate, onTemplateChange)
const ChatWindow: React.FC<ChatWindowProps & { selectedTemplate: string, onTemplateChange: (t: string) => void, onLoadNewChat: () => void }> = ({ messages, setMessages, loadChat, chatPartnerName, suggestedMessage, onSend, availableTemplates = [], introText, onIntroClose, isLoading = false, selectedTemplate, onTemplateChange, onLoadNewChat }) => {

  const [currentMessage, setCurrentMessage] = useState('');
  // const [selectedTemplate, setSelectedTemplate] = useState('template_one'); // Lifted to App.tsx
  const messageListRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Scroll to bottom logic
    if (messageListRef.current) {
      messageListRef.current.scrollTop = messageListRef.current.scrollHeight;
    }
  }, [messages]);

  useEffect(() => {
    if (suggestedMessage && suggestedMessage !== "") {
      setCurrentMessage(suggestedMessage);
    } else {
      // if suggested is empty, we don't necessarily clear it, or do we?
      // The user might be typing? 
      // But usually we clear after send.
      // If suggestedMessage is cleared by parent, we might clear here?
      // Let's assume parent clears it after send.
    }
  }, [suggestedMessage]);




  const handleSendMessage = async (e: React.FormEvent) => {
    e.preventDefault();

    const text = currentMessage.trim();
    if (text === '') return;

    // Call parent handler
    if (onSend) {
      onSend(text);
    }

    setCurrentMessage('');
  };

  return (
    <div className="chat-container" style={{ position: 'relative' }}>
      {introText && onIntroClose && (
        <ChatIntroPopup
          title={chatPartnerName}
          content={introText}
          onClose={onIntroClose}
        />
      )}
      <div className="chat-header" style={{ justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <img src="https://via.placeholder.com/40" alt="avatar" className="avatar" />
          <div className="contact-info">
            <h3>{chatPartnerName}</h3>
            <p>online</p>
          </div>
        </div>
        <button
          onClick={() => {
            if (onLoadNewChat) {
              onLoadNewChat();
            } else if (availableTemplates.length > 0) {
              // Fallback (should typically not be reached if prop provided)
              const randomTemplate = availableTemplates[Math.floor(Math.random() * availableTemplates.length)];
              onTemplateChange(randomTemplate);
              loadChat(randomTemplate, true);
            }
          }}
          style={{
            padding: '6px 16px',
            fontSize: '0.9rem',
            color: 'white',
            background: 'rgba(255,255,255,0.15)',
            border: '1px solid rgba(255,255,255,0.3)',
            borderRadius: '20px',
            cursor: 'pointer',
            fontWeight: 500,
            transition: 'background 0.2s'
          }}
          onMouseOver={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.25)'}
          onMouseOut={(e) => e.currentTarget.style.background = 'rgba(255,255,255,0.15)'}
        >
          ↻ Neuer zufälliger Chat
        </button>
      </div>

      <div className="message-list" ref={messageListRef}>
        {messages.map((msg) => (
          <Message key={msg.id} message={msg} />
        ))}
        {isLoading && (
          <div className="message bot">
            <div className="typing-indicator">
              <span></span><span></span><span></span>
            </div>
          </div>
        )}
      </div>

      <form className="message-input-form" onSubmit={handleSendMessage}>
        <input
          type="text"
          value={currentMessage}
          onChange={(e) => setCurrentMessage(e.target.value)}
          placeholder="Type a message..."
          disabled={isLoading}
        />
        <button type="submit" disabled={isLoading}>
          &#x27A4;
        </button>
      </form>
    </div >
  );
};

export default ChatWindow;